import React from 'react'
import { Typography } from '@jota-ds/lib-react'

export default function One() {
    return (
        <>
            <section className="home d-flex">
                <div className="container-fluid d-flex">
                    <div className="d-flex box m-2 m-md-3 mt-3">
                        <div className="d-flex flex-column box-sub ms-4 me-4 ms-md-5 me-md-5">
                            <div className="box-top d-flex justify-content-center position-relative">
                                <div className="vector-1">
                                    <img alt="" src="/assets/vector1.svg" />
                                </div>
                            </div>
                            <div className="box-center position-relative d-flex flex-column align-items-center justify-content-center">
                                <div className="d-flex card-title align-items-center">
                                    <img  data-aos="slide-right" data-aos-once="true" className="d-none d-md-block img-fluid me-5" alt="" src="/assets/union1.svg" />
                                    <div data-aos="zoom-in" data-aos-once="true" className="p-3 w-100 title d-flex justify-content-center">
                                        <Typography component="heading" size="x-small">MEIUCA APRESENTA</Typography>
                                    </div>
                                    <img data-aos="slide-left" data-aos-once="true" className="d-none d-md-block img-fluid ms-5" alt="" src="/assets/union2.svg" />
                                </div>
                                <div className="p-3 bilhete d-flex justify-content-center">
                                    <img className="img-fluid lettering-shape" alt="" src="/assets/lettering-shape.svg" />
                                </div>
                                <img className="d-none d-md-block camada1" alt="" src="/assets/camada1.svg" />

                                <div className="vector-3">
                                    <img className="animation-down" alt="" src="/assets/union3.svg" />
                                </div>
                            </div>

                            <div className="box-bottom d-flex justify-content-center align-items-center position-relative">
                                <div className="row vector-2 ps-3 pe-3">
                                    <div className="col-4 d-flex justify-content-end">
                                        <img className="img-fluid" alt="" src="/assets/union4.svg" />
                                    </div>
                                    <div className="col-4 d-flex justify-content-center">
                                        <img className="img-fluid union-center" alt="" src="/assets/logo.svg" />
                                    </div>
                                    <div className="col-4 d-flex justify-content-start">
                                        <img className="img-fluid union-rotate" alt="" src="/assets/union4.svg" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="scroll-animate">&nbsp;</div>
        </>
    )
}